/*
 * Generated type guards for "process.model.ts".
 * WARNING: Do not manually change this file.
 */
import { Process, ProcessStateMap } from './process.model'

export function isProcess(obj: unknown): obj is Process {
  const typedObj = obj as Process
  return (
    typedObj === 'DMX' ||
    typedObj === 'HF' ||
    typedObj === 'JTC' ||
    typedObj === 'KS' ||
    typedObj === 'PFA' ||
    typedObj === 'PFC' ||
    typedObj === 'SBP' ||
    typedObj === 'SMX' ||
    typedObj === 'TCT' ||
    typedObj === 'VBF' ||
    typedObj === 'EPF' ||
    typedObj === 'TLK'
  )
}

export function isProcessStateMap(obj: unknown): obj is ProcessStateMap {
  const typedObj = obj as ProcessStateMap
  return (
    ((typedObj !== null && typeof typedObj === 'object') ||
      typeof typedObj === 'function') &&
    (typeof typedObj['DMX'] === 'undefined' ||
      typedObj['DMX'] === false ||
      typedObj['DMX'] === true) &&
    (typeof typedObj['HF'] === 'undefined' ||
      typedObj['HF'] === false ||
      typedObj['HF'] === true) &&
    (typeof typedObj['JTC'] === 'undefined' ||
      typedObj['JTC'] === false ||
      typedObj['JTC'] === true) &&
    (typeof typedObj['KS'] === 'undefined' ||
      typedObj['KS'] === false ||
      typedObj['KS'] === true) &&
    (typeof typedObj['PFA'] === 'undefined' ||
      typedObj['PFA'] === false ||
      typedObj['PFA'] === true) &&
    (typeof typedObj['PFC'] === 'undefined' ||
      typedObj['PFC'] === false ||
      typedObj['PFC'] === true) &&
    (typeof typedObj['SBP'] === 'undefined' ||
      typedObj['SBP'] === false ||
      typedObj['SBP'] === true) &&
    (typeof typedObj['SMX'] === 'undefined' ||
      typedObj['SMX'] === false ||
      typedObj['SMX'] === true) &&
    (typeof typedObj['TCT'] === 'undefined' ||
      typedObj['TCT'] === false ||
      typedObj['TCT'] === true) &&
    (typeof typedObj['VBF'] === 'undefined' ||
      typedObj['VBF'] === false ||
      typedObj['VBF'] === true) &&
    (typeof typedObj['EPF'] === 'undefined' ||
      typedObj['EPF'] === false ||
      typedObj['EPF'] === true) &&
    (typeof typedObj['TLK'] === 'undefined' ||
      typedObj['TLK'] === false ||
      typedObj['TLK'] === true)
  )
}
